import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChatState, selectUiState } from '../../../../store/app.selectors';

import { BaseComponent } from '../../../shared/components/base/base.component';
import { uiInitialState } from '../../../shared/store/ui.reducer';
import { IChannel } from '../../interfaces/IChannel';
import { ChannelsService } from '../../services/channels.service';
import { loadChannels, setChannelsFilter } from '../../store/chat.actions';
import { AppStateWithChat, chatInitialState } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-channels-list',
  templateUrl: './channels-list.component.html',
  styleUrls: ['./channels-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelsListComponent extends BaseComponent {
  private store = inject(Store<AppStateWithChat>);
  private channelsService = inject(ChannelsService);

  ui = toSignal(this.store.select(selectUiState), { initialValue: uiInitialState });
  chat = toSignal(this.store.select(selectChatState), { initialValue: chatInitialState });

  channels = computed(() => this.channelsService.sortChannels([...this.chat().channels]));

  constructor() {
    super();
  }

  selectChannel(channel: IChannel) {
    this.channelsService.selectChannel(channel);
    this.channelsService.openChannelInfo();
  }

  onScroll() {
    const channelsFilter = this.chat().channelsFilter;
    if (!this.ui().isAllChannelsLoaded) {
      this.store.dispatch(setChannelsFilter({ filter: { ...channelsFilter, page: channelsFilter.page + 1 } }));
      this.store.dispatch(
        loadChannels({
          autoSelectChannel: false,
          setLoading: true,
          concat: true,
        })
      );
    }
  }
}
